// extracted by mini-css-extract-plugin
export default {"cls1":"T9aXA9AcLmTDhEop6lTs","cls2":"_FAwAJq0fiXVLanzPEv2 T9aXA9AcLmTDhEop6lTs"};